var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppointmnets(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.046,
    height: 20.962,
    viewBox: "0 0 16.046 20.962",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_75563",
    "data-name": "Group 75563",
    transform: "translate(-49.978 -299.519)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "meeting",
    transform: "translate(34.978 299.522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_141954",
    "data-name": "Path 141954",
    d: "M99.655,84.585V80H99v4.585a.327.327,0,0,0,.655,0Z",
    transform: "translate(-70.246 -66.9)",
    fill: "#61373f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17815",
    "data-name": "Ellipse 17815",
    cx: 2.621,
    cy: 2.621,
    r: 2.621,
    transform: "translate(20.402 -0.003)",
    fill: "#61373f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141955",
    "data-name": "Path 141955",
    d: "M41.953,27.592h.224a2.353,2.353,0,0,1,2.325,2.26V32.24h.667V29.852A3.027,3.027,0,0,0,42.758,27a3.009,3.009,0,0,1-.806.592Zm-5.286,2.26a2.353,2.353,0,0,1,2.325-2.26h.224A3.009,3.009,0,0,1,38.411,27,3.027,3.027,0,0,0,36,29.852V32.24h.667Z",
    transform: "translate(-17.562 -22.578)",
    fill: "#61373f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17816",
    "data-name": "Ellipse 17816",
    cx: 2.621,
    cy: 2.621,
    r: 2.621,
    transform: "translate(20.402 6.549)",
    fill: "#61373f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141956",
    "data-name": "Path 141956",
    d: "M18.6,66.66v2.7a.66.66,0,0,0,.658.661h.815a1.475,1.475,0,0,0,.982,1.388v1.068a.327.327,0,1,0,.655,0V71.5H24.5v.982a.327.327,0,1,0,.655,0V71.341a1.474,1.474,0,0,0,.819-1.318h.815a.66.66,0,0,0,.658-.661v-2.7A2.948,2.948,0,0,0,24.557,63.8H21.49A2.949,2.949,0,0,0,18.6,66.66Zm2.887-2.2h3.067a2.276,2.276,0,0,1,2.232,2.2l0,2.708H25.97V66.748a.82.82,0,0,0-.819-.819H20.894a.82.82,0,0,0-.819.819v2.615h-.819v-2.7A2.276,2.276,0,0,1,21.49,64.456Zm-4.2,5.076V64.947h-.655v4.585a.327.327,0,0,0,.655,0Zm-1.965-5.24h3.6a3.587,3.587,0,0,1,2.369-1.14A2.974,2.974,0,0,1,20.346,62H15.982a.984.984,0,0,0-.982.982v.982A.327.327,0,0,0,15.327,64.292Zm9.426-1.14a3.587,3.587,0,0,1,2.369,1.14h3.6a.327.327,0,0,0,.327-.327v-.982A.984.984,0,0,0,30.064,62H25.7a2.974,2.974,0,0,1-.947,1.153Z",
    transform: "translate(0 -51.848)",
    fill: "#61373f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmnets);
export default __webpack_public_path__ + "static/media/appointmnets.9157ecf9f74699926ed17c137f004a4c.svg";
export { ForwardRef as ReactComponent };